// Module
var code = "<div style=\"display:flex;justify-content:flex-end;padding-bottom:10px\"> <button data-bind=\"click: performLocationSearch\" class=\"btn btn-primary\">Search</button> </div> <div id=\"jqxLocations\"></div>";
// Exports
export default code;